import LayoutComponent from "../components/LayoutComponent";

export default function Announcements(){

    return (
        <LayoutComponent title={"Duyurular"} links={
            [
                {
                    title: 'Duyurular',
                    url: '/announcements'
                },

            ]}
        >
            <div>dsfsd</div>
        </LayoutComponent>
    )
}
